import { useAsyncDebouncedCallback } from "@tanstack/react-pacer";
import type { SearchParams } from "../../types/ui/views";
import { InputSearch } from "../form/input/InputSearch";

export interface DataViewFiltersProps {
  searchParams: SearchParams;
  onSearchParamsChange: (params: SearchParams) => void;
  renderNewRecord?: () => React.ReactNode;
}

const DataViewFilters = ({
  searchParams,
  onSearchParamsChange,
  renderNewRecord,
}: DataViewFiltersProps) => {
  const debouncedSearchByKeywords = useAsyncDebouncedCallback(
    async (keywords: string) => {
      onSearchParamsChange({
        ...searchParams,
        source: "keywords",
        keywords,
        inProgress: {
          ...searchParams.inProgress,
          keywords: true,
          filters: false,
        },
      });
    },
    {
      wait: 1000,
    },
  );

  return (
    <div className="flex space-x-2">
      {renderNewRecord && renderNewRecord()}

      <InputSearch
        loading={searchParams.inProgress.keywords}
        onSearch={debouncedSearchByKeywords}
      />
    </div>
  );
};

export { DataViewFilters };
